import { CSSProperties } from 'react';
import {
  DropdownMenuItem,
  Checkbox,
  CheckedState,
} from '@bst/react-ui';
import { ConditionalFitTooltip } from '../../ConditionalFitTooltip/Views/ConditionalFitTooltip';

// Filter Menu width is 300
// Filter checkbox is 32
// Paddings are 16
// Checkbox and label gap is 8
// 300 - 32 - 16 - 16 - 8 = 228
const FILTER_ITEM_WIDTH = 228

type Props = {
  label: string;
  isChecked: boolean;
  onCheckedChange: (checked: CheckedState) => void
  style?: CSSProperties
};

/**
 * Single Filter Item in CellFilter dropdown menu
 */
export const CellFilterItem = ({
  label,
  isChecked,
  onCheckedChange,
  style
}: Props) => {

  return (
    <DropdownMenuItem
      tabIndex={undefined}
      onSelect={(event) => event.preventDefault()}
      style={style}
    >
      <ConditionalFitTooltip text={label} threshold={FILTER_ITEM_WIDTH}>
        <Checkbox
          invertColors
          label={label}
          checked={isChecked}
          onCheckedChange={onCheckedChange}
        />
      </ConditionalFitTooltip>
    </DropdownMenuItem>
  )
}
